import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * When landing on /#anchor from another route, react-router keeps you at the
 * top of the page because the browser has already fired scrolling before the
 * target section is mounted. This hook waits for the target element and
 * smooth-scrolls to it after render.
 */
export default function useHashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
      return;
    }
    const id = hash.slice(1);
    let tries = 0;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (tries++ < 20) setTimeout(attempt, 80);
    };
    attempt();
  }, [pathname, hash]);
}
